// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2ASSn","choiceBoxes":"toolbarselects_choiceBoxes__32r-g","simpleField":"toolbarselects_simpleField__2Rf9G"};